import { useEffect, useRef, useState } from 'react';
import emailjs from '@emailjs/browser';

const labelMap = {
  idle: "Send",
  sending: "Sending...",
  success: "Message sent!",
  error: "Error sending, try again.",
};

const Contact = () => {
    const [status, setStatus] = useState("idle");
    const isDisabled = (status !== "idle");
    const resetTimerRef = useRef(null);

    useEffect(() => {
        return () => {
            if (resetTimerRef.current) {
                clearTimeout(resetTimerRef.current);
            }
        };
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isDisabled) return;
        setStatus("sending");
        
        try {
            const formData = new FormData(e.target);
            const data = Object.fromEntries(formData);

            await emailjs.send(
                process.env.REACT_APP_EMAILJS_SERVICE_ID,
                process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
                {
                    from_name: data.name,
                    from_email: data.email,
                    message: data.message,
                },
                {
                    publicKey: process.env.REACT_APP_EMAILJS_USER_ID
                }
            )
            
            setStatus("success");
            e.target.reset();
        } catch (error) {
            setStatus("error");
            console.log(error);
        } finally {
            resetTimerRef.current = setTimeout(() => {
                setStatus("idle");
            }, 3000);
        }
    };

    return (
        <main className="flex-column medium-gap">
            <h2>Send Fan Mail</h2>
            <form onSubmit={handleSubmit} className="contact flex-column small-gap">
                <input maxLength={100} name="name" placeholder="Name" required type="text" />
                <input maxLength={100} name="email" placeholder="Email" required type="email" />
                <textarea maxLength={1000} name="message" placeholder="Message" required />
                <button disabled={isDisabled} type="submit" className="contact__button">
                    {labelMap[status]}
                </button>
            </form>  
        </main>
    );
};

export default Contact;